import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const [state, setState] = useState({ status: "checking", payment_status: "pending" });

  useEffect(() => {
    if (!sessionId) {
      setState({ status: "missing", payment_status: "unknown" });
      return;
    }
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        setState(data);
        if (data.payment_status !== "paid" && attempts < 15) {
          attempts += 1;
          setTimeout(poll, 2000);
        }
      } catch (e) {
        if (attempts < 5) {
          attempts += 1;
          setTimeout(poll, 2000);
        } else {
          setState({ status: "error", payment_status: "unknown" });
        }
      }
    };
    poll();
  }, [sessionId]);

  const paid = state.payment_status === "paid";

  return (
    <div className="min-h-screen bg-[#111111] text-[#e0e0e0] flex items-center justify-center px-6">
      <div className="max-w-md w-full border border-[#262626] bg-[#171717] p-10 text-center" data-testid="payment-success-page">
        <div className="mono text-xs uppercase tracking-widest text-[#facc15] mb-3">Direct Settlement</div>
        <h1 className="editorial text-4xl text-white mb-4">
          {paid ? "DEPOSIT CONFIRMED" : "CONFIRMING PAYMENT"}
        </h1>
        <p className="text-sm text-[#a3a3a3] leading-relaxed mb-8" data-testid="payment-status-text">
          {paid
            ? "Your booking deposit has been received and will be credited against your final invoice. Kratos dispatch will be in touch."
            : "We are verifying your transaction with the payment network. This usually takes a few seconds."}
        </p>
        <div className="mono text-[10px] uppercase tracking-widest border border-[#262626] text-[#a3a3a3] px-4 py-1.5 inline-block mb-8" data-testid="payment-status-badge">
          Status: {state.payment_status}
        </div>
        <div>
          <Link
            to="/"
            data-testid="payment-success-home-link"
            className="mono text-xs uppercase tracking-widest px-6 py-3.5 bg-[#facc15] text-black font-bold hover:bg-[#eab308] transition-colors inline-block"
          >
            Return to Kratos
          </Link>
        </div>
      </div>
    </div>
  );
}
